import { useEffect } from 'react';
import Spinner from '@/components/Spinner';
import { enterDemoMode } from '@/demo/demoMode';

/**
 * Public /demo entry point (linked from the landing page). Flips the demo flag on and
 * hard-navigates into the app so auth/org/query state rebuilds against the fixtures.
 */
export default function DemoEntryPage() {
  useEffect(() => {
    enterDemoMode();
    window.location.replace('/dashboard');
  }, []);

  return (
    <div className="centered-full">
      <Spinner label="Preparing your demo workspace…" />
    </div>
  );
}
